import { Component } from '@angular/core';
import { FOOTER_MENU_ITEMS } from '@app/shared/common/constants';

@Component({
  selector: 'app-footer-menu',
  templateUrl: './footer-menu.component.html',
  styleUrls: ['./footer-menu.component.scss'],
})
export class FooterMenuComponent {
  menuItems = FOOTER_MENU_ITEMS;

  constructor() { }
}
